import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Main from "./Main";


export default class App extends React.Component {

  render() {
    return (
      <React.Fragment>
        <Main/>
      </React.Fragment>
    )
  }

}